import { parse_yyyymmddhhmm, pvmStringLong } from "src/components/js/statics1";
import { useLomaData } from "src/context/LomaContext";

export default function LomaActionsInfo() {
  const { selectedAction, selectedCell } = useLomaData();

  return <div style={{ display: "flex", gap: 6 }}></div>;
}
